module.exports = __webpack_public_path__ + "static/media/nyl-location-map.ca616d7e.jpeg";